module.exports = __webpack_public_path__ + "img/L_3D.7f2d695f.png";